import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'instagram-post',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss']
})

export class InstagramComponent implements OnInit {

  InstagramPost: Object;
  InstagramInfo: Object;
  public errorMsg;

  constructor(private _http: HttpService) { }

  ngOnInit(): void {
    this._http.instagramPost().subscribe(
      data => {
        this.InstagramInfo = data.data[0].user.profile_picture;
        this.InstagramPost = data.data.slice(0,4);
      },
      error => this.errorMsg = error
    );
  } 

}
